import React, { useEffect, useRef } from 'react';
import { arrayOf, func, number, shape } from 'prop-types';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { listStyles } from '../carrier-authorizations/sidebar/selector/Selector.styles';

const SelectorVirtualizer = ({
  handleSelectorClick,
  itemSize,
  overscanCount,
  selectorComponent,
  selectorsData,
}) => {
  const listRef = useRef();

  useEffect(() => {
    // only update on data changes this will not fire on mount
    // listRef.current is not present on mount
    if (listRef.current) {
      // reset select list card cache whenever itemData changes in VariableSizeList
      listRef.current.resetAfterIndex(0);
    }
  }, [selectorsData]);

  return (
    <AutoSizer>
      {({ height, width }) => (
        <List
          height={height}
          itemCount={selectorsData.length}
          itemData={{
            handleSelectorClick,
            selectorsData,
          }}
          itemSize={itemSize}
          overscanCount={overscanCount}
          ref={listRef}
          sx={listStyles}
          width={width}
        >
          {selectorComponent}
        </List>
      )}
    </AutoSizer>
  );
};

export default SelectorVirtualizer;

SelectorVirtualizer.propTypes = {
  handleSelectorClick: func,
  itemSize: func.isRequired,
  overscanCount: number.isRequired,
  selectorComponent: shape({}).isRequired,
  selectorsData: arrayOf(
    shape({
      activatedLocations: shape({}),
    })
  ).isRequired,
};

SelectorVirtualizer.defaultProps = {
  handleSelectorClick: () => {},
};
